import { styled, ButtonBase } from "@mui/material";
import { type ReactNode } from "react";

import { Badge } from "@/components/Badge/Badge";
import type { ButtonProps } from "@/components/Button";

const StyledButton = styled(ButtonBase)(() => ({
  flexDirection: "column",
  gap: "calc(var(--spacing)*2)",
  color: "var(--color-text-interactive)",
  fontWeight: "500",
  fontSize: "14px",
  letterSpacing: "0",
  lineHeight: "20px",
  borderRadius: "var(--radius-2xl)",
  padding: "calc(var(--spacing)*2)",
  width: "80px",
  backgroundColor: "var(--color-white)",
  transition: "transform 0.2s ease-in-out",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

type SearchNavigationButtonProps = {
  badgeContent?: ReactNode;
} & ButtonProps;

export const SearchNavigationButton = ({
  badgeContent,
  children,
  ...buttonProps
}: SearchNavigationButtonProps) => {
  const button = <StyledButton {...buttonProps}>{children}</StyledButton>;

  if (!badgeContent) return button;

  return <Badge badgeContent={badgeContent}>{button}</Badge>;
};
